/**
 * Route for `api-tracking`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ApiTrackingPage } from "../features/api-tracking/ApiTrackingPage";

export const apiTrackingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/api-tracking",
	component: ApiTrackingPage,
});

export default apiTrackingRoute;
